import React from 'react';
import Skeleton, {SkeletonProps} from '@material-ui/lab/Skeleton';

export type ButtonSkeletonProps = SkeletonProps;

//NOTE: do NOT change default props, just pass overriding props for customizations
const ButtonSkeleton: React.FC<ButtonSkeletonProps> = ({children, ...props}) => (
    <Skeleton width={150} height={60} {...props}>
        {children}
    </Skeleton>
);

export default ButtonSkeleton;
